module.exports = __webpack_public_path__ + "img/jobrainbow.4d4fd25.png";